import React from 'react';

import { FormattedMessageWrappedInSpan } from '../misc';

export default function FotoFlatMsg(props) {
  return <FormattedMessageWrappedInSpan id="messages.fotoFlat" defaultMessage="Foto-Flat" />;
}
